module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"content":{"headline":"Automate follow-ups for appointments","instructions":{"title":"Automate follow-ups for appointments","subtitle":"Trigger a follow-up when a contact books or cancels an appointment."}}}}')
  delete Component.options._Ctor
}
